import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Alert } from './alert.model';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private snackBar: MatSnackBar) { }

	show(alert: Alert) {
		this.snackBar.open(alert.message, 'x', {
			duration: alert.duration,
			panelClass: ['alert-snackBar']
		});
	}

	dismiss() {
		this.snackBar.dismiss();
	}
}
